<div class="inner-container">
  @if (isloading) {
    <mat-progress-bar mode="indeterminate" value="80" class="mb-15"> </mat-progress-bar>
  }
  <!-- <button mat-flat-button color="primary" class="primary-btn" routerLink="solutions-wizard/dar-settings">
  Configure
</button> -->
<table mat-table [dataSource]="dataSource" matSort>
  <!-- Solution Name Column -->
  <ng-container matColumnDef="solutionName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let element">{{ element.status }}</td>
  </ng-container>

  <!-- Action Column -->
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
    <td mat-cell *matCellDef="let element">
      <ng-container>
        <span [matTooltip]="actionHint" [matTooltipDisabled]="canToggleState(element)" matTooltipPosition="above"
          matTooltipShowDelay="200" matTooltipTouchGestures="auto">

          <mat-slide-toggle class="mat-accent" [checked]="isEnabled(element)" [labelPosition]="'after'"
            [hideIcon]="true" [disabled]="!canToggleState(element)"
            (change)="changeStatus($event, element.solution_id)">
          </mat-slide-toggle>
        </span>
      </ng-container>
      @if (element.status.toLowerCase() === 'available') {
        <button mat-flat-button color="primary" class="primary-btn" routerLink="./{{ element.solution_id }}"
          routerLinkActive="active" ariaCurrentWhenActive="page" #darsettings="routerLinkActive">
          Configure
        </button>
      }
      @if (element.status.toLowerCase() != 'available') {
        <button mat-flat-button color="primary" routerLink="./{{ element.solution_id }}" class="secondary-solid-btn"
          routerLinkActive="active" ariaCurrentWhenActive="page" #darsettings="routerLinkActive">
          View
        </button>
      }
    </td>
  </ng-container>
  <tr class="header-shadow" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr mat-row *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      No entitled solutions
    </td>
  </tr>

</table>
</div>
